/** @import module */

import cookies                          from "js-cookie";

import { NavLink }                      from "react-router-dom";

import { useTranslation }               from "react-i18next";

/** @import models */

import { NavigationModel }              from "../../../Models/Services";

/** @import components */

import ComponentLoader                  from "../../Layout/Loaders/Loader";

/**
 * 
 * @returns services navigation widget component
 * 
 */

const Navigation = () => { const { t } = useTranslation (),
    
    { loading, data } = NavigationModel (),

    /** @returns services collection */

    Collection = ( { object, status } ) => {

        /** load component fallback */

        if ( status ) return <ComponentLoader />

        /** filter by active entries and language */

        const filter = object.services.edges.filter ( obj => obj.node.language === cookies.get ( 'i18next' ) && obj.node.isActive === true );

        return filter.map ( ( service, index ) => <li key={ index }>

            <NavLink to={ `/${ t ( "__permalink_content__" ) }/${ t ( "__permalink_services__" ) }/${ service.node.id }/${ encodeURIComponent ( service.node.title ) }` } className={ ( { isActive } ) => ( isActive ? 'active' : 'inactive' ) }>

                { service.node.title }

            </NavLink>

        </li> );

    }

    /** @return component */

    return ( <div className="navigation">

        <ul>

            <Collection object={ data } status={ loading } />

        </ul>

    </div> );

}

/** @export Navigation */
 
export default Navigation;